import { Card } from '../../components/ui/card';
import { Trophy } from 'lucide-react';
import { inr } from './fmt';

export const TopTrainer = ({ top, quarter }) => (
  <Card className="p-4 flex flex-wrap items-center gap-4 border-amber-200 bg-gradient-to-r from-amber-50 to-white" data-testid="tt-top-trainer">
    <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center"><Trophy className="w-5 h-5 text-amber-600" /></div>
    {top ? (
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-wider text-amber-700 font-semibold">Top trainer · {quarter}</div>
        <div className="text-lg font-bold text-slate-900" data-testid="tt-top-trainer-name">{top.name}</div>
        <div className="text-xs text-slate-600">Billed {inr(top.billed)} of {inr(top.target)} target · <b className="text-emerald-700" data-testid="tt-top-trainer-pct">{top.billed_pct}%</b></div>
      </div>
    ) : <div className="text-sm text-slate-500" data-testid="tt-top-trainer-empty">No billing against a target in {quarter} yet.</div>}
  </Card>
);
